import { Component, PropsWithChildren } from "react";
import { navigateTo } from "../utils/browserUtils";
import { isNotFoundError, handleApiErrors } from "../api";
import { promiseShape } from "../shapes";

type Props = {
  handleNotFound?: boolean;
  submitCallback?: promiseShape;
  onError?: $TSFixMeFunction;
};

export class ApiErrorsHandler extends Component<PropsWithChildren<Props>> {
  componentDidUpdate(prevProps: Props) {
    const { onError } = prevProps;
    if (!onError || !onError(prevProps, this.props)) {
      this.handleErrors(this.props);
    }
  }

  handleErrors(nextProps: $TSFixMe) {
    const { handleNotFound, submitCallback } = this.props;
    if (handleNotFound && isNotFoundError(nextProps.errors)) {
      navigateTo("/404");
    } else {
      // @ts-expect-error TS(2554) FIXME: Expected 4 arguments, but got 3.
      handleApiErrors(submitCallback, this.props, nextProps);
    }
  }

  render() {
    return <span role="alert">{(this.props as $TSFixMe).children}</span>;
  }
}

export default ApiErrorsHandler;
